const FatalError = () => {
    return <>Ошибка! Что-то сломалось</>
}

export default FatalError;